export default "__VITE_ASSET__C9eI89n5__"